/*
*
* JS Imports
*
* */

import {
    Nav, MiniAccount, Account,
    Home, ProductCard,
    Cookies, TemplateTwo,
    PDP, PCP, PCPLanding,
    MiniCart, Marketing, Story, Contact,
    Animate, Instafeed, Cart,
    TAH, Yotpo, Forgot, View3DSection,
    PDPSections, Video, Concierge, Referrals, Csr, Gifthy,
    Testimonials, RingSizer, Modal, QuickView, Millenials
} from "./scripts/components";

import accordion from './scripts/helpers/accordion';

import {selectArr, selectDoc} from "./scripts/utils/utils";
import {initFCollectionProductCard, initNewsletterPopUp} from "./scripts/components/component.home";

/*
*
* App Initialization
*
* */
const app = {
    init: async () => {
        accordion.init();

        /**
         * Modals
         */
        new Modal();

        /**
         * Mini Account
         */
        if (selectDoc('#ws-account')) {
            MiniAccount.init();
        }

        /**
         * Mini Cart
         */
        if (selectDoc('#ws-minicart')) {
            MiniCart.init();
        }

        /**
         * Navigation
         */
        if (selectDoc('#navbar')) {
            Nav.init();
        }

        /**
         * Product Page
         */
        if (selectDoc('#pdp')) {
            let pdp = new PDP('#product-main-section');
            PDPSections.init();
            Gifthy.init(pdp);
            QuickView.init('set');
        }

        /**
         * Product Category Page
         */
        if (selectDoc('#pcpLanding')) {
            PCPLanding.init();
        }

        /**
         * Marketing Cart
         */
        if (selectDoc('#ws-marketing')) {
            Marketing.init();
        }

        /**
         * My Account Page
         */
        if (selectDoc('#ws-my-account')) {
            Account.init();
        }

        /**
         * Forgot/Recover Password
         */
        if (selectDoc('#forgot-password')) {
            Forgot.init();
        }

        /**
         * Home Page
         */
        if (selectDoc('#homepage')) {
            Home.init();
        }

        /**
         * Testimonials
         */
        if (selectDoc('#testimonials-section')) {
            Testimonials.init();
        }

        /**
         * Product Card Section
         */
        if (selectDoc('.product-card')) {
            ProductCard.init();
        }

        /**
         * Template Two Page
         */
        if (selectDoc('#ws-template-two')) {
            TemplateTwo.init();
        }

        /**
         * Product Category Page
         */
        if (selectDoc('#pcp') || selectDoc('#search')) {
            PCP.init();
        }

        if (selectDoc('.section-featured-collection')) {
            initFCollectionProductCard(selectArr(`.section-featured-collection .product-card`), false);
        }

        /**
         * Story Page
         */
        if (selectDoc('#our-story')) {
            Story.init();
        }

        /**
         * Contact Us Page
         */
        if (selectDoc('.contact-page')) {
            Contact.init();
        }

        /**
         * Instagram Feed
         */
        if (selectDoc('#insta-feed')) {
            Instafeed.init();
        }

        /**
         * Cookies
         */
        if (selectDoc("#cookies-container")) {
            Cookies.init();
        }

        /**
         * Cart - warranty
         */
        if (selectDoc("#shopify-section-cart-template")) {
            Cart.init();
        }

        /**
         * Try-at-Home
         */
        if (selectDoc("#tah")) {
            TAH.init();
        }

        /**
         * Yotpo
         */
        if (selectDoc(".yotpo-module")) {
            Yotpo.init();
        }

        /**
         * View 3D Section
         */
        View3DSection.init();

        /**
         * Concierge Page
         */
        if (selectDoc("#concierge-page")) {
            Concierge.init();
        }

        /**
         * Referrals Page
         */
        if (selectDoc("#refcandy-candyjar")) {
            Referrals.init();
        }

        /**
         * CSR Page
         */
        if (selectDoc("#page-csr")) {
            Csr.init();
        }

        /**
         * Animations
         */
        Animate.init();

        /**
         * Videos
         */
        new Video(".video-section");

        /**
         * Videos
         */
        new RingSizer(".ringsizer-section");

        setTimeout(function () {
            initNewsletterPopUp();
        }, 5000);

        /**
         * New Landing Page
         */
        if (selectDoc('#millenials-lp')) {
            Millenials.init();
        }
    }
};

app.init()
